var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlovenia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005da4",
    d: "M0 8h30v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 8H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1c23",
    d: "M30 24H0v-8h30zM9.27 2.7c-2.08 0-3.54.76-3.54.76s.14 1.85.3 4.7C6.22 11 9.28 12 9.28 12s3.06-1 3.23-3.85c.17-2.84.3-4.69.3-4.69s-1.45-.77-3.53-.77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#004a77",
    d: "M12.47 3.31a8.6 8.6 0 0 0-6.4 0c0 .2.12 2.31.27 4.77.16 2.57 2.93 3.48 2.93 3.48s2.77-.9 2.92-3.48z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.17 10.08c-.32 0-.48.2-.96.2s-.56-.2-.88-.2c-.25 0-.4.11-.6.17.76.56 1.54.79 1.54.79a3 3 0 0 0 1.56-.8c-.25-.05-.4-.16-.66-.16M8.37 8.8c.3 0 .57.24.9.24s.56-.24.9-.24c.3 0 .69.39 1.26.17q.23-.37.38-.78l-1.16-1.65-.57.7-.81-1.55-.77 1.55-.56-.74s-.5.6-1.33 1.71q.16.4.38.7c.65.33 1.1-.1 1.37-.1m2.74.7c-.43 0-.6-.25-.93-.25-.32 0-.48.24-.96.24s-.56-.24-.88-.24c-.33 0-.5.24-.8.24a1 1 0 0 1-.34-.08q.18.25.36.45c.36-.03.62-.25.81-.25.31 0 .58.25.9.25.34 0 .57-.25.91-.25.22 0 .48.21.82.25q.16-.2.27-.4l-.16.03"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd0",
    d: "m8.52 3.51.2.22-.28-.07-.09.28-.08-.28-.29.07.2-.22-.2-.21.29.07.08-.28.09.28.28-.07zm1.94 0 .2.22-.29-.07-.08.28-.09-.28-.29.07.2-.22-.2-.21.29.07.09-.28.08.28.29-.07zm-1 1.3.2.2-.29-.06-.09.28-.08-.28-.29.07.2-.22-.2-.21.29.06.08-.28.1.28.28-.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovenia);
export default __webpack_public_path__ + "static/media/slovenia.4ec7396ac4697c95dda47a7a80e6ca08.svg";
export { ForwardRef as ReactComponent };